const DISMISSED_COOKIE_NAME = 'domainTransitionBannerDismissed';
const ONE_YEAR_IN_SECONDS = 60 * 60 * 24 * 365;

export const isDomainTransitionBannerDismissed = (): boolean => {
  try {
    return document.cookie.split('; ').some((cookie) => cookie === `${DISMISSED_COOKIE_NAME}=true`);
  } catch {
    // document.cookie may be unavailable (e.g. blocked by browser settings)
    return false;
  }
};

// Cookie-backed instead of localStorage: expires on its own in a year rather
// than persisting indefinitely with no cleanup path.
export const dismissDomainTransitionBanner = (): void => {
  try {
    const secureAttribute = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = `${DISMISSED_COOKIE_NAME}=true; max-age=${ONE_YEAR_IN_SECONDS}; path=/; SameSite=Lax${secureAttribute}`;
  } catch {
    // document.cookie may be unavailable (e.g. blocked by browser settings)
  }
};
